/*
  Collection product cards: image slider (all widths).
  Markup: snippets/product-grid-item.liquid (.ndg-card-slider). Styles: custom.css.
  Swiping is native CSS scroll-snap; this moves the progress bar thumb and
  handles the prev / next arrows and mouse drag. The listeners are delegated
  (scroll in the capture phase, since it does not bubble) so cards
  re-rendered by the AJAX filters work without re-initialising.
*/
(function () {
  function update(track) {
    var slider = track.closest('[data-ndg-card-slider]');
    var thumb = slider && slider.querySelector('.ndg-card-slider__thumb');
    if (!thumb) return;
    var slides = track.children.length;
    var max = track.scrollWidth - track.clientWidth;
    var progress = max > 0 ? track.scrollLeft / max : 0;
    // The thumb is 1/slides wide, so it travels (slides - 1) of its own widths.
    thumb.style.transform = 'translateX(' + progress * (slides - 1) * 100 + '%)';
  }

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (track.classList && track.classList.contains('ndg-card-slider__track')) {
      window.requestAnimationFrame(function () { update(track); });
    }
  }, true);

  // One slide plus the CSS gap between slides.
  function stepOf(track) {
    var slides = track.children;
    return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
  }

  // Prev / next arrows (shown on hover): one image back or forward, wrapping
  // around at either end.
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('[data-ndg-card-slider-step]');
    if (!arrow) return;
    e.preventDefault();
    var slider = arrow.closest('[data-ndg-card-slider]');
    var track = slider && slider.querySelector('.ndg-card-slider__track');
    if (!track) return;
    var count = track.children.length;
    var step = stepOf(track);
    var index = Math.round(track.scrollLeft / step) + parseInt(arrow.getAttribute('data-ndg-card-slider-step'), 10);
    index = (index + count) % count;
    track.scrollTo({ left: index * step, behavior: 'smooth' });
  });

  // Mouse drag (touch already swipes natively), e.g. a narrow desktop window.
  var drag = null;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = e.target.closest && e.target.closest('.ndg-card-slider__track');
    if (!track) return;
    drag = { track: track, startX: e.clientX, startLeft: track.scrollLeft, moved: false };
    track.style.scrollSnapType = 'none';
    e.preventDefault(); // no native image drag / text selection
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.startX;
    if (Math.abs(dx) > 5) drag.moved = true;
    drag.track.scrollLeft = drag.startLeft - dx;
  });

  document.addEventListener('pointerup', function () {
    if (!drag) return;
    var track = drag.track;
    var width = track.clientWidth;
    var step = stepOf(track);
    var target = Math.round(track.scrollLeft / step) * step;
    var dx = track.scrollLeft - drag.startLeft;
    // A short flick is enough to move one slide.
    if (drag.moved && Math.abs(dx) > width * 0.15 && Math.abs(dx) < width * 0.5) {
      target = Math.round(drag.startLeft / step) * step + (dx > 0 ? step : -step);
    }
    track.scrollTo({ left: target, behavior: 'smooth' });
    window.setTimeout(function () { track.style.scrollSnapType = ''; }, 400);
    if (drag.moved) {
      // Swallow the click that follows a drag so it doesn't open the product.
      var stop = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      };
      document.addEventListener('click', stop, { capture: true, once: true });
      // The click fires right after pointerup; drop the guard if none came.
      window.setTimeout(function () {
        document.removeEventListener('click', stop, { capture: true });
      }, 50);
    }
    drag = null;
  });
})();

/*
  Equal title heights per row on collection pages: every .product-grid-title
  in a row of cards gets the height of the tallest one, so a title that wraps
  onto two lines doesn't push its price and colour dots below the rest of the
  row. Rows are the visible cards sharing the same top position, so it follows
  the 1 / 2 / 3+ column layouts. Re-run on load, resize and whenever the grid
  changes (filters, "Show more", Color filter, grid switcher).
*/
(function () {
  var section = document.getElementById('main-collection-product-grid');
  if (!section) return;
  var frame = null;

  function equalize() {
    frame = null;
    var titles = Array.prototype.slice.call(section.querySelectorAll('.collection-list > li .product-grid-title'));
    titles.forEach(function (t) { t.style.minHeight = ''; });

    var rows = {};
    titles.forEach(function (t) {
      var li = t.closest('li');
      if (!li || li.offsetParent === null) return; // hidden (e.g. Color filter)
      var top = Math.round(li.getBoundingClientRect().top + window.scrollY);
      (rows[top] = rows[top] || []).push(t);
    });

    Object.keys(rows).forEach(function (top) {
      var row = rows[top];
      if (row.length < 2) return;
      var max = 0;
      row.forEach(function (t) { max = Math.max(max, t.getBoundingClientRect().height); });
      row.forEach(function (t) { t.style.minHeight = max + 'px'; });
    });
  }

  function schedule() {
    if (frame === null) frame = window.requestAnimationFrame(equalize);
  }

  schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  // Grid content replaced or appended, cards hidden / shown (class on the
  // card's <li>), grid mode switched. Other class / style changes, like lazy
  // images or the slider bar moving, are ignored.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && (m.target.matches('.collection-list') || m.target.id === 'CollectionProductGrid')) return schedule();
      if (m.type === 'attributes' && (m.target === section || m.target.tagName === 'LI')) return schedule();
    }
  }).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-ndg-grid-mode'] });
})();
